import React from 'react';
import { Flex, Text } from '@chakra-ui/react';
import PropType from 'prop-types';

function UserRole({ role, departments }) {
  if (!role) return null;

  return (
    <Flex
      color="primaryScale.300"
      fontSize="sm"
      textAlign="left"
      width="100%"
    >
      <Text
        fontWeight="medium"
      >
        {role}
      </Text>
      {
        departments && (
          <Text children={`: ${departments.join(', ')}`} />
        )
      }
    </Flex>
  );
}

UserRole.propTypes = {
  role: PropType.string,
  departments: PropType.arrayOf(PropType.string)
};

export default UserRole;
